import React from 'react';
import { SliderMenuOptionImage, SliderMenuContainer, OptionContainer, SliderMenuInnerContainer, OptionLabelContainer, OptionImageContainer, SliderMenuSpacer } from './SliderMenu-styled';



interface Props {
  options:SliderMenuOption[],
  selectedValue:string,
  onChange:(value:string)=>void,

  optionTileWidth?:number,
  optionTileHeight?:number,
  imageSize?:number
}

export interface SliderMenuOption {
  label:string,
  value:string,
  imageURI:string
}

export class SliderMenu extends React.Component<Props,{}> {
  public innerContainerRef:React.RefObject<HTMLDivElement> = React.createRef();

  constructor(props) {
    super(props)
  }

  public static defaultProps = {
    optionTileWidth: 90,
    optionTileHeight: 90
  }

  componentDidUpdate = () => {
    this.scrollToOption(this.props.selectedValue);
  }

  scrollToOption = (optionValue:string) => {
    if (!this.innerContainerRef.current) return;
    const { options, optionTileWidth } = this.props;
    const index = options.findIndex((el) => el.value === optionValue);
    this.innerContainerRef.current.scroll(index*optionTileWidth, 0);
  }

  render = () => {
    const { 
      options, 
      selectedValue, 
      onChange,
      optionTileWidth,
      optionTileHeight,
      imageSize
    } = this.props;

    let parentWidth:number = window.innerWidth;
    if (this.innerContainerRef.current) parentWidth = this.innerContainerRef.current.parentElement.parentElement.getBoundingClientRect().width;

    /* We want spacers to take up the bare minimum width needed so first and last option can be centered */
    const spacerWidth = parentWidth/2 - optionTileWidth/2;

    return (
      <SliderMenuContainer optionTileWidth={optionTileWidth} optionTileHeight={optionTileHeight} imageSize={imageSize}>
        <SliderMenuInnerContainer ref={this.innerContainerRef}>
          <SliderMenuSpacer width={spacerWidth}/>

          {options.map((option) => {
            return (
              <OptionContainer 
                key={option.label}
                title={option.label}
                selected={option.value===selectedValue}
                onClick={() => {
                  onChange(option.value);
                  this.scrollToOption(option.value);
                }}
              >
                <OptionImageContainer>
                  <SliderMenuOptionImage className={option.value===selectedValue ? "selected" : ""}
                    src={option.imageURI}
                  />
                </OptionImageContainer>
                <OptionLabelContainer>{option.label}</OptionLabelContainer>
              </OptionContainer>
            )
          })}

          <SliderMenuSpacer width={spacerWidth}/>
        </SliderMenuInnerContainer> 
      </SliderMenuContainer>
    )
  }
  

  
};